<template>
  <div id="app">
    <main>
      <section class="intro">
        <p>QUELLES DYNAMIQUES POUR LES VILLES AÉROPORTUAIRES DE FRANCE ?<img src="https://www.flaticon.com/svg/static/icons/svg/2332/2332056.svg" alt="inNout icon" width="60" style="display:inline;"></p>
        <p>
          Zoom sur la ville de {{selected}}
        </p>
        <div class="select is-medium">
          <select id="allAirports" @change="updateSelectedAirport">
            <option
              v-for="airport in allAirports"
              :key="airport"
              v-bind:value="airport"
            >
              {{ airport }}
            </option>
          </select>
        </div>
        <p><br /><br /><br /><br /><br />SCROLL TO CONTINUE</p>
      </section>

      <section class="scrolly" id="scrolly">
        <figure ref="figure">
          <div class="globalContainer">
            <div id="map" ref="map">
              <div id="popupHover" style="position: absolute"></div>
              <v-card id="insideMaps" elevation="12" width="256">
                <v-navigation-drawer floating permanent>
                  <v-list rounded>
            <button class="button is-danger" id="isEnable" @click="disableEnable">Désactiver l'animation</button>
                    <v-subheader class="my-5 pb-5">
                      Année d'observation</v-subheader
                    >
                    <v-list-item>
                      <v-slider
                        id="sliderYear"
                        v-model="sliderYear"
                        thumb-label="always"
                        :min="1999"
                        :max="2019"
                        step="5"
                        ticks="always"
                        tick-size="4"
                        @change="updateSelectedYear"
                      >
                      </v-slider>
                    </v-list-item>
                    <v-list-item>
                      <h3>
                        Trafic de passagers et de marchandises entre villes
                        aéroportuaires (plus de 5000 passagers / an)
                      </h3>
                    </v-list-item>
                    <v-list-item>
                        <h2>
                          La taille des cercles correspond au nombre total de passagers en {{selectedYear}}
                        </h2>
                    </v-list-item>
                    <v-list-item>
                      <span class="dotDifferentiel" style="background: rgb(26, 152, 255)"> </span><label class="m-2"> Entrants</label><br>
                      <span class="dotDifferentiel" style="background:rgb(255, 167, 35)"> </span><label class="m-2"> Sortants </label>
                    </v-list-item>
                     <v-list-item><i>Click droit sur la carte + drag pour changer l'orientation de celle-ci</i>
                    </v-list-item>
                  </v-list>
                </v-navigation-drawer>
              </v-card>
              <div class="datavizContainer">
                    <h3 class="title px-10 pt-5" style="color:white;">{{selected}}</h3>
                    <div style="width:100%; position:relative"><h1 class="subtitle mx-4" style="color:white; position:absolute">Son poids (en nombre de liaisons de plus de 5000 passagers) dans le système aéroportuaire de France Métropolitaine, en {{selectedYear}}</h1></div>
                    <label class="mx-5" style="width:100%; position:absolute; margin-top:100px!important; color:white">(cliquer sur un cercle pour changer d'aéroport)</label>
                <ArcPlot id="arcplot" name="arcplot" class="mx-2" :selectedAirport="selected" :year="selectedYear" :key="key" v-on:childToParent="getChildEmit"/>
                <div style="width:100%; position:relative"><h1 class="subtitle mx-4" style="color:white; ">Descriptif des liaisons :</h1></div>
                <Dataviz
                  :selected="selected"
                  :out="out"
                  :in="this.in"
                  :key="key"
                />
              </div>
            </div>
          </div>
        </figure>
        <article>
          <div class="step" data-step="1999" style="margin: 0 auto 65rem auto">
            <p>EXPLORATION SPATIO TEMPORELLE DU TRAFIC AÉRIEN DE LA VILLE
            AÉROPORTUAIRE DE<b> {{ selected }} </b></p><br />
            <span>Changez l'année avec le slider pour observer l'évolution depuis
                1999</span
            >
          </div>

          <div class="step" data-step="2004" style="margin: 0 auto 65rem auto;background-color:rgb(0,0,0,0);">
            <KeyNumbers :selected="selected" :key="selected" />
          </div>

        </article>
      </section>
      <section class="scrolly" id="scrolly">
        <figure ref="figure">
            <Map :selected="selected" :key="selected"/>
        </figure>
        <article>
          <div class="step" data-step="1999" style="margin: 0 auto 50rem auto">
            <p> EXPLORATION SPATIO TEMPORELLE DE LA FREQUENTATION DE LA VILLE
            AÉROPORTUAIRE DE<b> {{ selected }} </b></p><br />
            <span>
              Changez l'année et le type de flux pour observer l'évolution depuis
                2010, par an et par Mois
                </span>
          </div>

          <div class="step" data-step="2004" style="margin: 0 auto 20rem auto;background-color:rgb(0,0,0,0);">
            <p></p>
          </div>
        </article>
      </section>
      <div class="outro">
        <h2 class="subtitle mx-5 my-5" style="position: relative">
          Synthèse des dynamiques des villes aéroportuaires de France <strong v-if="selected != 'PARIS'">(hors Paris)</strong>
        </h2>
        <DatavizSynthese :selected="selected" :key="selected" />
      </div>
    </main>
    <footer class="footer">
  <div class="content has-text-centered">
    <p>
      <strong>Quelles dynamiques pour le trafic aérien de passagers en France ?</strong> par <a href="https://twitter.com/QuentinNahelou">Quentin Nahélou</a>.
       avec <a href="https://vuejs.org/">Vue</a>.
      <a href="https://deck.gl/">DeckGL</a>.
      <a href="https://www.chartjs.org/">Chart.js</a>
      et <a href="https://docs.mapbox.com/mapbox-gl-js/api/">MapBoxGl</a>
      préparation de la donnée avec <a href="https://postgis.net/">PostGis</a>
      <br>Travail effectué dans le cadre du <a href="https://cartomob.sciencesconf.org/resource/page/id/14">Mapathon,</a>
      vous trouverez toutes les informations sur les données : <a href="https://github.com/gflowiz/mapathon">ici</a>
    </p>
  </div>
</footer>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import {
  ScatterplotLayer,
  ArcLayer,
} from "@deck.gl/layers";
import {
  MapboxLayer
} from "@deck.gl/mapbox";
import dataFly from "../data/DATA_OK.json";
import * as d3 from "d3";
import "intersection-observer";
import scrollama from "scrollama";
import Map from "@/components/Map.vue";
import KeyNumbers from "@/components/KeyNumbers.vue";
import DatavizSynthese from "@/components/DatavizSynthese.vue";
import ArcPlot from "@/components/ArcPlot.vue";
import Dataviz from "@/components/Dataviz.vue";


const vsDeclaration = `
attribute float instanceFrequency;
varying float vArcLength;
varying float vFrequency;`;
const vsMain = `
vArcLength = distance(source, target);
vFrequency = instanceFrequency;
`;
const fsDeclaration = `
uniform float tailLength;
uniform float timestamp;
uniform float animationSpeed;

varying float vArcLength;
varying float vFrequency;`;
const fsColorFilter = `
float tripDuration = vArcLength / animationSpeed;
float flightInterval = 1.0 / vFrequency;
float r = mod(geometry.uv.x, flightInterval);

// Head of the trip (alpha = 1.0)
float rMax = mod(fract(timestamp / tripDuration), flightInterval);
// Tail of the trip (alpha = 0.0)
float rMin = rMax - tailLength / vArcLength;
// Two consecutive trips can overlap
float alpha = (r > rMax ? 0.0 : smoothstep(rMin, rMax, r)) + smoothstep(rMin + flightInterval, rMax + flightInterval, r);
if (alpha == 0.0) {
  discard;
}
color.a *= alpha;
`;

class ArcBrushingLayer extends ArcLayer {
  getShaders() {
    const shaders = super.getShaders();
    shaders.inject = {
      "vs:#decl": vsDeclaration,
      "vs:#main-end": vsMain,
      "fs:#decl": fsDeclaration,
      "fs:DECKGL_FILTER_COLOR": fsColorFilter,
    };
    return shaders;
  }

  initializeState(params) {
    super.initializeState(params);

    this.getAttributeManager().addInstanced({
      instanceFrequency: {
        size: 1,
        accessor: "getFrequency",
        defaultValue: 1,
      },
    });
  }

  draw(opts) {
    this.state.model.setUniforms({
      tailLength: this.props.tailLength,
      animationSpeed: this.props.animationSpeed,
      timestamp: (Date.now() / 1000) % 86400,
    });
    super.draw(opts);

    this.setNeedsRedraw();
  }
}

mapboxgl.accessToken =
  "pk.eyJ1IjoibmFoZWxvdSIsImEiOiJjazUxOG9yNDcwcDUyM3NtaTVzMnd5ejdrIn0.hFTRn-SVqOhufKAcRCnYLA";

export default {
  components: {
    Map,
    KeyNumbers,
    DatavizSynthese,
    ArcPlot,
    Dataviz
  },
  data() {
    return {
      isFirst: true,
      data_fly: dataFly,
      enable: true,
      airports: [],
      out: null,
      in: null,
      dcat_years: ["1999", "2004", "2009", "2014", "2019"],
      map: null,
      sliderYear: "1999",
      selectedYear: null,
      cbFlux: "Nombre total de dessertes",
      selectedFluxType: "dessertes",
      inFlowColors: [255, 255, 0],
      outFlowColors: [177, 0, 38],
      inFlowColorsInc: [255, 255, 255],
      outFlowColorsInc: [0, 51, 204],
      termes: {
        eurostats: {
          PAS_CRD: "Nombre de passagers transportés",
          PAS_TRS: "Nombre de passagers en transit direct",
          PAS_TRF: "Nombre de passagers transférés",
          FRM_LD_NLD: "Quantité estimée de marchandises chargée et déchargée : fret et courrier",
          ACM: "Mouvements d’avions  commerciaux et non commerciaux (passagers, fret et courrier)",
          CACM: "Mouvements d’avions commerciaux (passagers, fret et courrier)",
        },
        dgac: {
          dessertes: "Nombre total de dessertes",
          dessertes_reg: "Nombre de dessertes régulières",
          dessertes_non_reg: "Nombre de dessertes non régulières",
          pax_total: "Nombre total de passagers locaux + en transit des vols commerciaux (sans double compte)",
          pax_reg: "Nombre total de passagers d'un vol régulier",
          pax_non_reg: "Nombre total de passagers d'un vol non régulier",
          fret_total: "Poids total estimé de marchandises d'un vol",
        },
      },
      mini: true,
      accessToken: "pk.eyJ1IjoibmFoZWxvdSIsImEiOiJjazUxOG9yNDcwcDUyM3NtaTVzMnd5ejdrIn0.hFTRn-SVqOhufKAcRCnYLA",
      mapStyle: "mapbox://styles/nahelou/cjzokkh6s0rq31cqnu7blj9bd",
      mapData: "https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json",
      latitude: 46.4832668,
      longitude: 2.1491635,
      zoom: 6,
      bearing: 40,
      pitch: 55,
      allAirports: [
        "CLERMONT-FERRAND",
        "AGEN",
        "AJACCIO",
        "ANGERS",
        "ANGOULEME",
        "ANNECY",
        "AURILLAC",
        "AVIGNON",
        "BALE-MULHOUSE",
        "BASTIA",
        "BEAUVAIS",
        "BERGERAC",
        "BEZIERS",
        "BIARRITZ",
        "BORDEAUX",
        "BREST",
        "BRIVE",
        "CAEN",
        "CALVI",
        "CARCASSONNE",
        "CASTRES-MAZAMET",
        "CHALONS",
        "CHAMBERY",
        "CHERBOURG",
        "DIJON",
        "EPINAL",
        "FIGARI",
        "GRENOBLE",
        "LANNION",
        "LA-ROCHELLE",
        "LE-HAVRE",
        "LE-PUY-EN-VELAY",
        "LILLE",
        "LIMOGES",
        "LORIENT",
        "LYON",
        "MARSEILLE",
        "METZ-NANCY",
        "MONTPELLIER",
        "NANTES",
        "NICE",
        "NIMES",
        "PARIS",
        "PAU",
        "PERIGUEUX",
        "PERPIGNAN",
        "POITIERS",
        "QUIMPER",
        "RENNES",
        "ROANNE",
        "RODEZ",
        "ROUEN",
        "ST-BRIEUC",
        "ST-ETIENNE",
        "ST-NAZAIRE",
        "STRASBOURG",
        "TARBES",
        "TOULON",
        "TOULOUSE",
        "TOURS",
      ],
      airportsNotDGAF: [
        "ALBERT-PICARDIE",
        "DOLE",
        "CHATEAUROUX",
        "CANNES",
        "ST-MALO",
        "DEAUVILLE",
        "LE-MANS",
        "REIMS",
      ],
      isAirportNotDGAF: 0,
      scroller: scrollama(),
      currStep: null,
      key: 0,
      selected: "CLERMONT-FERRAND",
      width: 500,
      height: 300,
      step: 0,
      progress: 0,
      margin: 64,
    };
  },
  created() {
    this.map = null;
  },
  mounted() {
    this.scroller
      .setup({
        step: ".scrolly article .step",
        offset: 0.5,
        progress: true,
        debug: false,
      })
      .onStepEnter(this.onEnter)
      .onStepProgress(this.onProgress)
      .onStepExit(this.onExit);

    this.resize();
    window.addEventListener("resize", this.resize);
    this.data_fly.features.forEach((element) => {
      let airport = {};
      airport.name = element.properties.ville;
      airport.coordinates = element.geometry.coordinates;
      // airport.dcat_year = Object.keys(element.properties.dcat_all);
      this.airports.push(airport);
    });

    this.map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/nahelou/cjfgvxuancvbz2rsvvudroksj",
      center: [this.longitude, this.latitude],
      zoom: this.zoom,
      pitch: this.pitch,
    });
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.scrollZoom.disable();

    this.map.on("load", () => {
      if (!this.selectedYear) this.selectedYear = "1999";
      this.key = this.key + 1;
      this.addArcLayer();
      this.getEntrants();

      this.map.flyTo({
        center: [
          this.dataOrigine.geometry.coordinates[0],
          this.dataOrigine.geometry.coordinates[1],
        ],
        essential: true,
      });
    });
  },
  computed: {
    innerHeight() {
      return this.height - this.margin * 2;
    },
    innerWidth() {
      return this.width - this.margin * 2;
    },
    barWidth() {
      return this.innerWidth / this.data.length;
    },
  },
  methods: {
    updateSelectedAirport(event) {
      this.selected = event.target.value;
      this.key = this.key + 1;
      if (this.airportsNotDGAF.indexOf(this.selected) >= 0) {
        this.isAirportNotDGAF = 1;
      } else {
        this.isAirportNotDGAF = 0;
      }
      if (this.isAirportNotDGAF == 0) {
        this.addArcLayer();
        this.getEntrants();
        this.map.flyTo({
          center: [
            this.dataOrigine.geometry.coordinates[0],
            this.dataOrigine.geometry.coordinates[1],
          ],
          essential: true,
        });
      }
    },
    resize() {
      const bounds = this.$refs.figure.getBoundingClientRect();
      this.width = bounds.width;
      this.height = bounds.height;
      this.scroller.resize();
    },
    onEnter(step) {
      this.step = step.index;
      switch (this.step) {
        case 5:
      }
    },
    onProgress(step) {
      this.step = step.index;
      this.progress = step.progress;
    },
    onExit(step) {
      this.step = step.index;
    },
    updateSelectedYear(event) {
      if (this.selectedYear != event) {
        this.selectedYear = event;
      }
      this.key = this.key + 1;
      this.addArcLayer();
      this.getEntrants();
    },
    updateSelectedFlowType(event) {
      if (this.selected != event.target.value)
        this.selected != event.target.value;
    },
    addArcLayer() {
      this.out = null;
      if (this.map.getLayer("arcLayer")) {
        this.map.removeLayer("arcLayer");
        this.map.removeLayer("scatterOut");
      }
      let origine = [];
      let dataToArcLayer = [];
      let out = [];
      let allSumOut = [];
      this.dataOrigine = this.data_fly.features.find(
        (element) => element.properties.ville == this.selected
      );
      origine.push(this.dataOrigine.geometry.coordinates);
      if (this.dataOrigine.properties.dcat_all) {
        let dataYearDgaf = this.dataOrigine.properties.dcat_all[
          this.selectedYear
        ];
        let dataByYearAllAirports = [];
        for (let e in dataYearDgaf) {
          let d = {};
          let dataByYearAirport = {};
          const dataDestination = this.airports.find(
            (element) => element.name == e
          );
          d.origine = origine;
          d.destination = dataDestination.coordinates;
          d.name = dataDestination.name;
          d.detail = dataYearDgaf[e];
          d.value = 0;
          for (let i in d.detail) {
            if (i != "fret_total") d.value = d.value + d.detail[i];
          }
          allSumOut.push(d.value);

          dataToArcLayer.push(d);
          dataByYearAirport[e] = dataYearDgaf[e];
          out.push(dataYearDgaf[e]);
          dataByYearAllAirports.push(dataByYearAirport);
        }

        let maxOut = d3.max(Object.values(allSumOut));
        let meanOut = d3.mean(Object.values(allSumOut));
        let minOut = d3.min(Object.values(allSumOut));

        let valued3 = d3
          .scaleLinear(10)
          .domain([minOut, meanOut, maxOut])
          .range([25, 50, 100, 150]);

        let valued3Freq = d3
          .scaleLinear(10)
          .domain([minOut, meanOut, maxOut])
          .range([2, 4, 8, 16]);


        this.out = out;
        const airportOut = new MapboxLayer({
          id: "scatterOut",
          type: ScatterplotLayer,
          data: dataToArcLayer,
          radiusScale: 500,
          getPosition: (d) => d.destination,
          getRadius: (d) => valued3(d.value),
          pickable: true,
          getColor: [255, 117, 26],
          radiusMinPixels: 2,
          onHover: (info) => this.hover1(info.object, 0, info.x, info.y),
        });
        let airportSelectedArcLayer = null;
        if (this.enable) {
          airportSelectedArcLayer = new MapboxLayer({
            id: "arcLayer",
            type: ArcBrushingLayer,
            data: dataToArcLayer,
            getSourcePosition: (d) => d.origine[0],
            getTargetPosition: (d) => d.destination,
            getSourceColor: this.inFlowColors,
            getTargetColor: this.outFlowColors,
            getWidth: (d) => valued3Freq(d.value),
            animationSpeed: 1,
            tailLength: 2,
            getFrequency: (d) => valued3Freq(d.value),
          });
        } else {
          airportSelectedArcLayer = new MapboxLayer({
            id: "arcLayer",
            type: ArcLayer,
            data: dataToArcLayer,
            getSourcePosition: (d) => d.origine[0],
            getTargetPosition: (d) => d.destination,
            getSourceColor: this.inFlowColors,
            getTargetColor: this.outFlowColors,
            getWidth: (d) => valued3Freq(d.value),
            animationSpeed: 0.5,
            tailLength: 2,
            getFrequency: 4,
          });
        }
        this.key = this.key + 1;
        this.map.addLayer(airportSelectedArcLayer);
        this.map.addLayer(airportOut);
      }
    },
    getEntrants() {
      if (this.map.getLayer("lineLayer")) {
        this.map.removeLayer("lineLayer");
        this.map.removeLayer("scatterIn");
      }
      this.in = null;
      let valuesFlow = [];
      let destination = [];
      let airportIn = [];
      let allSumIn = [];
      this.dataOrigine = this.data_fly.features.find(
        (element) => element.properties.ville == this.selected
      );
      destination.push(this.dataOrigine.geometry.coordinates);
      for (let i = 0; i < this.data_fly.features.length; i++) {
        if (this.data_fly.features[i].properties.dcat_all) {
          let fromAirport = {};
          if (
            this.data_fly.features[i].properties.dcat_all[this.selectedYear] &&
            this.data_fly.features[i].properties.dcat_all[this.selectedYear][
              this.selected
            ]
          ) {
            fromAirport.destination = destination;
            fromAirport.origine = this.data_fly.features[
              i
            ].geometry.coordinates;
            fromAirport.name = this.data_fly.features[i].properties.ville;
            fromAirport.detail = this.data_fly.features[i].properties.dcat_all[
              this.selectedYear
            ][this.selected];
            fromAirport.value = 0;
            for (let i in fromAirport.detail) {
              if (i != "fret_total")
                fromAirport.value = fromAirport.value + fromAirport.detail[i];
            }
            allSumIn.push(fromAirport.value);
            airportIn.push(
              this.data_fly.features[i].properties.dcat_all[this.selectedYear][
                this.selected
              ]
            );
            valuesFlow.push(fromAirport);
          }
        }
        this.in = airportIn;
      }

      let maxOut = d3.max(Object.values(allSumIn));
      let meanOut = d3.mean(Object.values(allSumIn));
      let minOut = d3.min(Object.values(allSumIn));

      let valued3 = d3
        .scaleLinear(10)
        .domain([minOut, meanOut, maxOut])
        .range([25, 50, 100, 150]);

      let valued3Freq = d3
        .scaleLinear(10)
        .domain([minOut, meanOut, maxOut])
        .range([2, 4, 8, 16]);

      if (valuesFlow) {
        const airportIn = new MapboxLayer({
          id: "scatterIn",
          type: ScatterplotLayer,
          data: valuesFlow,
          getPosition: (d) => d.origine,
          radiusScale: 500,
          pickable: true,
          getRadius: (d) => valued3(d.value),
          getColor: [0, 153, 255],
          radiusMinPixels: 2,
          onHover: (info) => this.hover1(info.object, 1, info.x, info.y),
        });
        let airportSelectedArcLayer = null;
        if (this.enable) {
          airportSelectedArcLayer = new MapboxLayer({
            id: "lineLayer",
            type: ArcBrushingLayer,
            data: valuesFlow,
            getHeight: 0,
            getSourcePosition: (d) => d.origine,
            getTargetPosition: (d) => d.destination[0],
            getSourceColor: this.inFlowColorsInc,
            getTargetColor: this.outFlowColorsInc,
            getWidth: (d) => valued3Freq(d.value),
            animationSpeed: 1,
            tailLength: 2,
            getFrequency: (d) => valued3Freq(d.value),
          });
        } else {
          airportSelectedArcLayer = new MapboxLayer({
            id: "lineLayer",
            type: ArcLayer,
            data: valuesFlow,
            getHeight: 0,
            getSourcePosition: (d) => d.origine,
            getTargetPosition: (d) => d.destination[0],
            getSourceColor: this.inFlowColorsInc,
            getTargetColor: this.outFlowColorsInc,
            getWidth: (d) => valued3Freq(d.value),
            animationSpeed: 0.5,
            tailLength: 2,
            getFrequency: 4,
          });
        }
        this.map.addLayer(airportSelectedArcLayer);
        this.map.addLayer(airportIn);
      }
    },
    disableEnable() {
      this.enable = !this.enable;
      let button = document.getElementById("isEnable")
      if (!this.enable) {
        button.className = "button is-success";
        button.innerHTML = "Activer l'animation";
      } else {
        button.className = "button is-danger";
        button.innerHTML = "Désactiver l'animation";
      }
      this.addArcLayer();
      this.getEntrants();
    },
    hover1(object, isIn, x, y) {
      const el = document.getElementById("popupHover");

      if (object) {
        el.innerHTML = "";
        let tableau = document.createElement("table");
        tableau.class = "table is-hoverable";
        tableau.cellspacing = "0";
        tableau.width = "80%";
        let villeH2 = document.createElement("div");
        villeH2.className = "subtitle";
        if (isIn) {
          villeH2.innerHTML =
            object.name.toUpperCase() + " => " + this.selected;
        } else {
          villeH2.innerHTML =
            this.selected + " => " + object.name.toUpperCase();
        }
        let body = document.createElement("tbody");
        for (let i in object.detail) {
          let data = document.createElement("tr");
          let type = document.createElement("td");
          type.innerHTML = this.termes.dgac[i];
          data.appendChild(type);
          let n = document.createElement("td");
          n.innerHTML = object.detail[i];
          data.appendChild(n);
          body.appendChild(data);
        }
        tableau.appendChild(body);
        el.appendChild(villeH2);
        el.appendChild(tableau);

        el.style.display = "block";
        el.style.left = x + 20 + "px";
        el.style.top = y + 30 + "px";
        el.style.backgroundColor = "white";
        el.style.borderRadius = "2px";
        el.style.padding = "10px";
        el.style.margin = "10px";
        el.style.lineHeight = "2";
        el.style.zIndex = "9999";
      } else {
        el.style.display = "none";
      }
    },
    getChildEmit(value) {
      this.selected = value;
      this.addArcLayer();
      this.getEntrants();
    }
  },
};
</script>

<style>
#scrolly {
  position: relative;
  padding: 1rem;
}

article {
  position: relative;
  padding: 0;
  max-width: 20rem;
  margin: 0 auto;
}

figure {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  width: 100%;
  margin: 0;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 0;
  background-color: var(--color-black);
  height: 100vh;
  margin: 0;
  top: 0;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.step {
  margin: 0 auto 10rem auto;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.1);
}

.step:last-child {
  margin-bottom: 0;
}

.step p {
  /* text-align: center; */
  padding: 1.5rem;
  font-size: 1.1rem;
}
section {
  width: 100%;
  max-width: var(--max-width);
  padding: var(--spacing) var(--spacing) 0 var(--spacing);
  hyphens: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.intro{
  margin: 5%;
  padding: 30vh;
}
.outro {
  margin: 2%;
  padding: 20vh;
}
#insideMaps {
  top: 10vh;
  margin: 1%;
  background-color: #fff;
  position: absolute;
  z-index: 1;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  font-family: "Open Sans", sans-serif;
}
.datavizContainer {
  top: 5vh;
  right: 0%;
  background-color: rgba(50, 50, 50, 0.8);
  position: absolute;
  z-index: 1;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  font-family: "Open Sans", sans-serif;
}
#map {
  height: 100vh;
  z-index: 0;
}
#sliderYear {
  cursor: pointer;
}
.dotDifferentiel {
  height: 20px;
  width: 20px;
  background-color: rgba(187, 187, 187, 0);
  border-radius: 50%;
}
#entrants {
}
#sortants {
  background-image: linear-gradient(
    to right top,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff4525,
    #ff5d2a,
    #ff7032,
    #ff813b,
    #ff9147,
    #ff9e46,
    #ffaa47,
    #ffb749,
    #ffc73c,
    #ffd92e,
    #ffec1b,
    #fbff00,
    #fbff00,
    #fbff00,
    #fbff00,
    #fbff00,
    #fbff00,
    #fbff00
  );
  height: 10px;
  border-radius: 5px;
  border: none;
  margin-top: 50px;
}
</style>
